import { render, staticRenderFns } from "./TheLayoutFooter.vue?vue&type=template&id=0575c232&scoped=true"
import script from "./TheLayoutFooter.vue?vue&type=script&lang=js"
export * from "./TheLayoutFooter.vue?vue&type=script&lang=js"
import style0 from "./TheLayoutFooter.vue?vue&type=style&index=0&id=0575c232&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0575c232",
  null
  
)

export default component.exports